export default __webpack_public_path__ + "static/media/bear_pic_1.a47ebf7d.png";